export default {
	computed: {
		gestiosField() {
			let field = null;
			if (this.app) field = this.$gestios.$cache.app(this.app).field(this.name);
			return field;
		},
		gestiosVars() {
			if (this.gestiosField) {
				const vars = this.gestiosField.Vars ? JSON.parse(this.gestiosField.Vars) : null;
				if (vars) return vars;
			}

			return null;
		},
		gestiosRules() {
			let rules = {};
			if (this.gestiosField && this.gestiosField.Parser) {
				const parse = this.gestiosField.Parser.split('|') || [this.gestiosField.Parser];

				if (parse) {
					const fRules = {};

					for (let i = 0; i < parse.length; i += 1) {
						const item = parse[i];
						const parsedRule = item.replace(/ *\[[^)]*\] */g, '');
						const parsedValue = item.match(/\[([^)]+)\]/) ? item.match(/\[([^)]+)\]/)[1] : '';

						fRules[parsedRule] = parsedValue || '';
					}

					rules = fRules;
				}
			}
			return rules;
		}
	}
};
